/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingAggregationRequestBatch {
    getFixupPrototypeFunction() { return BillingAggregationRequestBatch.fixupPrototype; }

    static newInstance(model: Partial<BillingAggregationRequestBatch>): BillingAggregationRequestBatch {
        let obj = Object.assign(new BillingAggregationRequestBatch(), model);
        BillingAggregationRequestBatch.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingAggregationRequestBatch>): BillingAggregationRequestBatch {
        if (!model) return null;
        return BillingAggregationRequestBatch.newInstance(<BillingAggregationRequestBatch> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingAggregationRequestBatch) {
        if (!obj) return;

        models.BillingAggregationRequestBatch.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingAggregationRequestBatch): boolean {
        Object.setPrototypeOf(obj, BillingAggregationRequestBatch.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.requests) {
            for (let val of this.requests) {
                models.BillingAggregationRequest.fixupPrototype(val);
            }
        }
    }

    /**
     * Batch of aggregation requests
     */
    requests: Array<models.BillingAggregationRequest>;

}
